import type { Item } from './api'
import { icsBlob, type Slot } from './growth'
import { fileSlug } from './format'

/** Hand an item's .ics file to the device's calendar (Apple devices lead with this). */
export function downloadIcs(item: Item, addId: string, slot: Slot, tz?: string, guests: string[] = []) {
  const url = URL.createObjectURL(icsBlob(item, addId, undefined, slot, tz, guests))
  const a = document.createElement('a')
  a.href = url
  a.download = `${fileSlug(item.title)}.ics`
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
